import React from 'react';
import { motion } from 'framer-motion';
import { Play, Disc } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useData } from '../components/DataContext';
import { Reveal, StaggerContainer, StaggerItem } from '../components/Reveal';
import useScrambleText from '../hooks/useScrambleText';
import ElectricCard from '../components/ElectricCard';

const Releases = () => {
  const { releases } = useData();
  const h2Ref = useScrambleText("Discography");
  const h3Ref = useScrambleText("Latest Transmissions");

  return (
    <section id="releases" className="py-16 pb-8 bg-black/50 relative">
      <div className="container mx-auto px-4">
        <Reveal>
          <div className="text-center mb-16">
            <h2 ref={h2Ref} className="text-primary font-heading text-sm tracking-[0.3em] uppercase mb-4 cursor-pointer">Discography</h2>
            <h3 ref={h3Ref} className="text-4xl md:text-5xl font-heading font-bold korov-gradient-text cursor-pointer">Latest Transmissions</h3>
          </div>
        </Reveal>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {releases.map((release) => (
            <StaggerItem key={release.id} className="group relative">
              <ElectricCard color="#00ff41">
                <div className="flex flex-col h-full">
                  {/* Image Container */}
                  <div className="relative aspect-square overflow-hidden flex-shrink-0">
                    <img 
                      src={release.cover} 
                      alt={release.title} 
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 group-hover:rotate-1"
                    />
                    {/* Overlay on Hover */}
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center gap-4 backdrop-blur-sm">
                      <Button size="icon" className="rounded-full bg-primary text-black hover:bg-white hover:scale-110 transition-all duration-300 shadow-[0_0_15px_hsl(var(--primary))]">
                        <Play className="w-5 h-5 ml-1" />
                      </Button>
                      <Button size="icon" variant="outline" className="rounded-full border-white text-white hover:bg-white hover:text-black hover:scale-110 transition-all duration-300">
                        <Disc className="w-5 h-5" />
                      </Button>
                    </div>
                  </div>

                  {/* Info */}
                  <div className="p-6 bg-card/50 backdrop-blur-sm">
                    <div className="flex justify-between items-start mb-2">
                      <h4 className="text-xl font-heading font-bold text-gradient-platinum group-hover:text-primary group-hover:text-glow transition-all duration-300">{release.title}</h4>
                      <span className="text-xs font-mono text-muted-foreground border border-white/10 px-2 py-1 group-hover:border-primary/30 transition-colors">{release.type}</span>
                    </div>
                    <p className="text-sm text-muted-foreground">{release.year} • Dharmar Records</p>
                  </div>
                </div>
              </ElectricCard>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
};

export default Releases;
